<template>
  <div v-show="menuActive" class="action-menu">
    <div class="menu-backdrop" @click="closeMenu" @contextmenu.prevent />
    <div class="menu" ref="menu" @click="closeMenu">
      <button @click="item.open()" v-if="selection.length || settings.openAction || item.readOnly">
        <div class="icon md-icon">open_in_new</div>
        <span>otwórz</span>
      </button>
      <button @click="item.edit()" v-if="!selection.length && !item.readOnly && settings.editAction">
        <div class="icon md-icon">edit</div>
        <span>edytuj treść</span>
      </button>
      <button @click="openSubMenu('date-menu')" v-if="!item.readOnly && ['task', 'note'].includes(item.type)">
        <div class="icon md-icon">calendar_today</div>
        <span>zmień datę</span>
      </button>
      <button @click="openSubMenu('list-menu')" v-if="!item.readOnly && item.type !== 'period' && (item.type !== 'list' || settings.nestedLists)">
        <div class="icon md-icon">drive_file_move_outline</div>
        <span>{{ hasParent ? "przenieś do..." : "dodaj do..." }}</span>
      </button>
      <button @click="startInsert" v-if="!item.readOnly && settings.insertAction">
        <div class="icon md-icon">save_alt</div>
        <span>wstaw do...</span>
      </button>
      <button @click="openSubMenu('color-menu')" v-if="!item.readOnly && item.type !== 'period'">
        <div class="icon md-icon">palette</div>
        <span>zmień kolor</span>
      </button>
      <button @click="item.duplicate()" v-if="!selection.length && !item.readOnly && ['task', 'note'].includes(item.type)">
        <div class="icon md-icon">content_copy</div>
        <span>duplikuj</span>
      </button>
      <button @click="archive" v-if="!item.readOnly && settings.allowArchiving">
        <div class="icon md-icon">archive</div>
        <span>archiwizuj</span>
      </button>
      <button @click="trash" v-if="item.isDeletable()">
        <div class="icon md-icon">delete</div>
        <span>usuń</span>
      </button>
      <button @click="item.copyIDtoClipboard()" v-if="!selection.length && settings.copyIdAction">
        <div class="icon md-icon">qr_code_2</div>
        <span>kopiuj ID</span>
      </button>
      <button @click="item.toggleAllElems()" v-if="context === 'header'">
        <div class="icon md-icon">dynamic_feed</div>
        <span>zaznacz wszystkie elementy</span>
      </button>
      <button @click="item.downloadAsText()" v-if="settings.dumpTextEnabled">
        <div class="icon md-icon">abc</div>
        <span>pobierz jako plik tekstowy</span>
      </button>
    </div>
  </div>
</template>

<style scoped>
.menu-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: var(--bg-color-hover);
}
.menu {
  z-index: 15;
  position: fixed;
  border-radius: var(--rounding-smaller);
  background-color: var(--bg-color-card-default);
  border: var(--menu-border);
  display: flex;
  flex-flow: column nowrap;
  max-height: 90vh;
  overflow-y: auto;
}
.icon {
  flex: var(--indent-size) 0 0;
  margin: 0;
}
button {
  min-height: var(--indent-size);
  min-width: 150px;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
button:hover {
  background: var(--bg-color-hover);
}
.menu span {
  text-align: left;
}
</style>

<script>
import selection from "../selection";
import settings from "@/synced-settings";
import { Item } from "../item";
import { REL_ELEM } from "@/structure";
import { getItem } from "@/reactive-cache";
import hintsShown from "@/hints";

export default {
  data() {
    return {
      settings: settings,
      selection: selection,
      menuActive: false,
      triggerEl: null,
      context: null,
      item: new Item({}, this.$reactiveCache, this.$defaultDB),
    };
  },
  computed: {
    hasParent() {
      return !!this.item.getParent(REL_ELEM);
    },
  },
  methods: {
    archive() {
      if (selection.length) {
        selection.archiveAll()
      } else {
        this.item.archive()
      }
    },
    trash() {
      if (selection.length) {
        selection.deleteAll()
      } else {
        this.item.trash()
      }
    },
    startInsert() {
      selection.add(this.item);
      selection.insertMode = true;
      if (!hintsShown.howToInsert) {
        window.alert(
          "Now click on the item into which you want to insert selected item.",
        );
        hintsShown.howToInsert = true;
      }
    },
    openSubMenu(name) {
      this.$root.$emit(name, { item: this.item, button: this.triggerEl });
    },
    openMenu() {
      this.menuActive = true;
      this.$nextTick(() => {
        // we need the size for calculations, so it has to render first
        this.setMenuPosition(this.$refs.menu);
      });
    },
    setMenuPosition(menu) {
      const viewport = document.getElementById("toplevel").getBoundingClientRect();

      const width = menu.offsetWidth;
      if (viewport.width > this.triggerEl.left + width) {
        menu.style.left = this.triggerEl.left + "px";
        menu.style.right = "auto";
      } else if (this.triggerEl.right > width) {
        menu.style.right = viewport.width - this.triggerEl.right + "px";
        menu.style.left = "auto";
      } else {
        menu.style.left = "5vw";
        menu.style.right = "auto";
      }

      const height = menu.offsetHeight;
      if (viewport.height > this.triggerEl.top + height) {
        menu.style.top = this.triggerEl.top + "px";
        menu.style.bottom = "auto";
      } else if (this.triggerEl.bottom > height) {
        menu.style.bottom = viewport.height - this.triggerEl.bottom + "px";
        menu.style.top = "auto";
      } else {
        menu.style.bottom = "5vh";
        menu.style.top = "auto";
      }
    },
    closeMenu() {
      this.menuActive = false;
    },
  },
  mounted() {
    this.$root.$on("action-menu", (data) => {
      this.triggerEl = data.button;
      this.context = data.placement;
      this.item = data.item;
      this.openMenu();
    });
  },
};
</script>
